// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Target the specific section */
.vendorDashboard_custom-scrollbar__mxIyp::-webkit-scrollbar {
  width: 1px; /* Adjust scrollbar width */
  height: 5px;
}

.vendorDashboard_custom-scrollbar__mxIyp::-webkit-scrollbar-track {
  background: var(--disabled-color); /* Track background color */
}

.vendorDashboard_custom-scrollbar__mxIyp::-webkit-scrollbar-thumb {
  background-color: var(--light-primary-color); /* Thumb color */
  border-radius: 10px; /* Optional: Rounded corners */
}

.vendorDashboard_custom-scrollbar__mxIyp::-webkit-scrollbar-thumb:hover {
  background: var(--para-color); /* Thumb hover effect */
}

.vendorDashboard_vendorModalColor__vInKj {
  background-color: var(--showModalBackground-color);
}

.vendorDashboard_tableRow__Cx6Hf {
  font-size: 13px !important; /* Ensures MUI does not override */

  padding: 0px 4px !important;
  border-left: 1px solid #efecec !important;
  border-right: 1px solid #efecec !important;
}

.vendorDashboard_formstyling__DPpiD {
  background: white;
  padding: 3.5rem 1.5rem;
  border-radius: 0.7rem;
  border: 1px solid gray;
  margin-top: 1.2rem;
}

.vendorDashboard_vendorHeading__FOjoZ {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  line-height: 1.75rem !important;
}

.vendorDashboard_vendorSection__Q5YG3 {
  min-height: 24vh;
}

.vendorDashboard_vendorSectionImg__4QMUz {
  border: 1px solid gray;
  border-radius: 0.3 rem;
  padding: 2px;
}

.vendorDashboard_vendorSectionError__98Wlx {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25vh;
}

.vendorDashboard_bg-blue-100__nhr0A {
  background-color: #ebf8ff;
}

.vendorDashboard_bg-green-100__tiuWp {
  background-color: #f0fff4;
}

.vendorDashboard_bg-yellow-100__cGkrl {
  background-color: #fffbeb;
}

.vendorDashboard_labelColor__6M1Jb {
  color: #36383a !important;
}

.vendorDashboard_labelErrorColor__l3qRS {
  color: #ff5555 !important;
}

.vendorDashboard_noPaddingTop__64UK2 {
  padding-top: 0px !important;
}

.vendorDashboard_custom1-scrollbar__1uVSh::-webkit-scrollbar {
  width: 5px; /* Adjust scrollbar width */
}

.vendorDashboard_custom1-scrollbar__1uVSh::-webkit-scrollbar-track {
  background: var(--disabled-color); /* Track background color */
}

.vendorDashboard_custom1-scrollbar__1uVSh::-webkit-scrollbar-thumb {
  background-color: var(--para-color); /* Thumb color */
  border-radius: 10px; /* Optional: Rounded corners */
}

.vendorDashboard_custom1-scrollbar__1uVSh::-webkit-scrollbar-thumb:hover {
  background: var(--para-color); /* Thumb hover effect */
}
`, "",{"version":3,"sources":["webpack://./src/styles/vendorDashboard.module.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,UAAU,EAAE,2BAA2B;EACvC,WAAW;AACb;;AAEA;EACE,iCAAiC,EAAE,2BAA2B;AAChE;;AAEA;EACE,4CAA4C,EAAE,gBAAgB;EAC9D,mBAAmB,EAAE,8BAA8B;AACrD;;AAEA;EACE,6BAA6B,EAAE,uBAAuB;AACxD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,0BAA0B,EAAE,kCAAkC;;EAE9D,2BAA2B;EAC3B,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU,EAAE,2BAA2B;AACzC;;AAEA;EACE,iCAAiC,EAAE,2BAA2B;AAChE;;AAEA;EACE,mCAAmC,EAAE,gBAAgB;EACrD,mBAAmB,EAAE,8BAA8B;AACrD;;AAEA;EACE,6BAA6B,EAAE,uBAAuB;AACxD","sourcesContent":["/* Target the specific section */\n.custom-scrollbar::-webkit-scrollbar {\n  width: 1px; /* Adjust scrollbar width */\n  height: 5px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: var(--disabled-color); /* Track background color */\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background-color: var(--light-primary-color); /* Thumb color */\n  border-radius: 10px; /* Optional: Rounded corners */\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: var(--para-color); /* Thumb hover effect */\n}\n\n.vendorModalColor {\n  background-color: var(--showModalBackground-color);\n}\n\n.tableRow {\n  font-size: 13px !important; /* Ensures MUI does not override */\n\n  padding: 0px 4px !important;\n  border-left: 1px solid #efecec !important;\n  border-right: 1px solid #efecec !important;\n}\n\n.formstyling {\n  background: white;\n  padding: 3.5rem 1.5rem;\n  border-radius: 0.7rem;\n  border: 1px solid gray;\n  margin-top: 1.2rem;\n}\n\n.vendorHeading {\n  font-size: 1.5rem !important;\n  font-weight: 700 !important;\n  line-height: 1.75rem !important;\n}\n\n.vendorSection {\n  min-height: 24vh;\n}\n\n.vendorSectionImg {\n  border: 1px solid gray;\n  border-radius: 0.3 rem;\n  padding: 2px;\n}\n\n.vendorSectionError {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 25vh;\n}\n\n.bg-blue-100 {\n  background-color: #ebf8ff;\n}\n\n.bg-green-100 {\n  background-color: #f0fff4;\n}\n\n.bg-yellow-100 {\n  background-color: #fffbeb;\n}\n\n.labelColor {\n  color: #36383a !important;\n}\n\n.labelErrorColor {\n  color: #ff5555 !important;\n}\n\n.noPaddingTop {\n  padding-top: 0px !important;\n}\n\n.custom1-scrollbar::-webkit-scrollbar {\n  width: 5px; /* Adjust scrollbar width */\n}\n\n.custom1-scrollbar::-webkit-scrollbar-track {\n  background: var(--disabled-color); /* Track background color */\n}\n\n.custom1-scrollbar::-webkit-scrollbar-thumb {\n  background-color: var(--para-color); /* Thumb color */\n  border-radius: 10px; /* Optional: Rounded corners */\n}\n\n.custom1-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: var(--para-color); /* Thumb hover effect */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"custom-scrollbar": `vendorDashboard_custom-scrollbar__mxIyp`,
	"vendorModalColor": `vendorDashboard_vendorModalColor__vInKj`,
	"tableRow": `vendorDashboard_tableRow__Cx6Hf`,
	"formstyling": `vendorDashboard_formstyling__DPpiD`,
	"vendorHeading": `vendorDashboard_vendorHeading__FOjoZ`,
	"vendorSection": `vendorDashboard_vendorSection__Q5YG3`,
	"vendorSectionImg": `vendorDashboard_vendorSectionImg__4QMUz`,
	"vendorSectionError": `vendorDashboard_vendorSectionError__98Wlx`,
	"bg-blue-100": `vendorDashboard_bg-blue-100__nhr0A`,
	"bg-green-100": `vendorDashboard_bg-green-100__tiuWp`,
	"bg-yellow-100": `vendorDashboard_bg-yellow-100__cGkrl`,
	"labelColor": `vendorDashboard_labelColor__6M1Jb`,
	"labelErrorColor": `vendorDashboard_labelErrorColor__l3qRS`,
	"noPaddingTop": `vendorDashboard_noPaddingTop__64UK2`,
	"custom1-scrollbar": `vendorDashboard_custom1-scrollbar__1uVSh`
};
export default ___CSS_LOADER_EXPORT___;
